export default __webpack_public_path__ + "static/media/event-dark.5a1cc15d.svg";